export default "__VITE_ASSET__DltYE9Lw__"